module.exports = __webpack_public_path__ + "img/bg02.11fc4af2.jpg";